// @flow
import React from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import type { FieldProps } from "redux-form";

type RadioButtonFieldType = {
    inputComponent: Element,
    children: Element | Array<Element>,
} & FieldProps;

const RFRadioButtonGroup = ({
    input,
    inputComponent,
    meta: { touched, error },
    children,
    ...custom
}: RadioButtonFieldType) => (
    <FormControl component="fieldset" fullWidth error={touched && error}>
        <RadioGroup
            aria-label="dateEvent"
            className="form__radioButton"
            name="dateEvent"
            input={inputComponent}
            {...input}
            onChange={event => input.onChange(event.target.value)}
            {...custom}
        >
            {children}
        </RadioGroup>
        {touched && error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
);

export default RFRadioButtonGroup;
